import './footer.css'
import { useRecoilValue } from 'recoil'
import { infoSite } from '../../state/atom'

export default function Footer() {
  const InfoSite = useRecoilValue(infoSite)
  const color = InfoSite.Colore.Rgba
  const stileDiv = {
    backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, 0.904)`,
  }
  function hrefLuis () {
    window.open('https://www.luisbeqja.com/', '_blank');
  }
  return (
    <div className={'footer'} style={stileDiv}>
      <p onClick={hrefLuis} > Credit Luis Beqja</p>
    </div>
  )
}
